import thingshappen from '../assets/thingshappen.webp';
import services01 from '../assets/services01.webp';
import services02 from '../assets/services02.webp';
import services03 from '../assets/services03.webp';
import services04 from '../assets/services04.webp';
import services05 from '../assets/services05.webp';
import services06 from '../assets/services06.webp';
import team01 from '../assets/team01.webp';
import hero from '../assets/hero.webp';
import chatGPTmascot from '../assets/new_openai_robot.webp';
import carpenter from '../assets/carpenter.webp';
import robotReading from '../assets/robot_reading.webp';
import robotByDesk from '../assets/robot_by_desk.webp';
import testimonial1 from '../assets/stephen_portrait.webp';
import testimonial2 from '../assets/linn_portrait.webp';
import testimonial3 from '../assets/erik_svedin.webp';
import testimonial4 from '../assets/peter.webp';
import hi from '../assets/hi.webp';
import logo from '../assets/logo512.webp';
import aiconsult from '../assets/ai_konsult_stockolm.webp';
import aiface from '../assets/ai_face.webp';
import brandlab from '../assets/brand_lab.webp';
import artaiLogo from '../assets/artai_logo.webp';
import sketchBench from '../assets/sketch_bench.webp';
import johannesProfile from '../assets/cropped_edit.webp';
import aiForBusiness from '../assets/ai_for_foretag.webp';
import o1 from '../assets/blogs/o1.webp';
import derailieure from '../assets/derailieure.webp';
import canva from '../assets/collaborative_workspace_with_openai_canva.webp';
import gemini from '../assets/blogs/google-gemini.webp';
import claudeAI from '../assets/blogs/claudeAI.webp';
import cykelNatur from '../assets/customers/cykel-natur.webp';
import golowLogo from '../assets/customers/golowLogo.webp';
import mysItalia from '../assets/customers/mys_italia.webp';
import husstainability from '../assets/customers/husstainability.webp';
import lillaStaderiet from '../assets/customers/lilla_staderiet.webp';
import o1Logo from '../assets/work_with/o1.webp';
import o4 from '../assets/work_with/4o.webp';
import chatgpt from '../assets/work_with/chatgpt.webp';
import dalle from '../assets/work_with/dalle.webp';
import gptForWork from '../assets/work_with/gpt_for_work.webp';
import allAi from '../assets/blogs/all_ai.webp';
import midjourneyGirl from '../assets/blogs/midjourney_girl.webp';
import customGPT from '../assets/blogs/custom_gpt.webp';
import aiAgent from '../assets/blogs/ai_agent.webp';
import o1_science from '../assets/blogs/o1_science.webp';
import deepSeek from '../assets/blogs/deep_seek.webp';
import deepSeekAppstore from '../assets/blogs/deep_seek_appstore.webp';
import deepSeekCost from '../assets/blogs/deep_seek_cost.webp';
import oCost from '../assets/blogs/cost_oone.webp';
import neuralNetwork from '../assets/blogs/neural_network.webp';
import deepResearch from '../assets/blogs/deep_research.webp';
import deepResearchLogo from '../assets/blogs/deep_research_logo.webp';
import brandLabHero from '../assets/brandlab/brand_lab_hero.webp';
import brandLabOverview from '../assets/brandlab/overview.webp';
import bikeParts from '../assets/bikeparts/pads_many.webp';
import bikePartsLogo from '../assets/bikeparts/logo.webp';
import bikePartsLogoDark from '../assets/bikeparts/logo_dark.webp';
import claudeVSchgptThumb from '../assets/blogs/claudevschatgot.webp';
import claudeVsLlm2026 from '../assets/blogs/claude-vs-llm-2026.webp';
import agentKit from '../assets/blogs/agentkit.webp';
import claudeCoworkImage from '../assets/blogs/claude_cowork.webp';
import claudeCoworkThumb from '../assets/blogs/claude_cowork_thumb.webp';
import claudeDesignThumb from '../assets/blogs/claude_design_thumb.webp';
import claudeCodeThumb from '../assets/blogs/claude_code.webp';

const i1 = '/assets/i1.svg';
const i2 = '/assets/i2.svg';
const i3 = '/assets/i3.svg';
const i4 = '/assets/i4.svg';
const i5 = '/assets/i5.svg';
const i6 = '/assets/i6.svg';
const openAILogo = '/assets/blogs/openai.svg';
const gptSol = '/assets/blogs/gpt_sol.webp';
const gpt6Astra = '/assets/blogs/gpt6_astra.webp';
const gpt6AstraBenchmark = '/assets/blogs/gpt6-astra-benchmark.webp';

const images = {
    thingshappen,
    services01,
    services02,
    services03,
    services04,
    services05,
    services06,
    team01,
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,
    carpenter,
    hero,
    chatGPTmascot,
    robotReading,
    i1,
    i2,
    i3,
    i4,
    i5,
    i6,
    hi,
    robotByDesk,
    logo,
    aiconsult,
    aiface,
    brandlab,
    artaiLogo,
    sketchBench,
    johannesProfile,
    aiForBusiness,
    derailieure,
    o1,
    canva,
    gemini,
    claudeAI,
    cykelNatur,
    golowLogo,
    mysItalia,
    husstainability,
    lillaStaderiet,
    o1Logo,
    o4,
    chatgpt,
    dalle,
    gptForWork,
    allAi,
    midjourneyGirl,
    customGPT,
    aiAgent,
    openAILogo,
    gptSol,
    gpt6Astra,
    gpt6AstraBenchmark,
    o1_science,
    deepSeek,
    deepSeekAppstore,
    oCost,
    deepSeekCost,
    neuralNetwork,
    deepResearch,
    deepResearchLogo,
    brandLabHero,
    brandLabOverview,
    bikeParts,
    bikePartsLogo,
    bikePartsLogoDark,
    claudeVsLlm2026,
    agentKit,
    claudeVSchgptThumb,
    claudeCoworkImage,
    claudeCoworkThumb,
    claudeDesignThumb,
    claudeCodeThumb
};

export default images;
